import { render, staticRenderFns } from "./OrthoTreatmentControls.vue?vue&type=template&id=41dff665&scoped=true&"
import script from "./OrthoTreatmentControls.vue?vue&type=script&lang=js&"
export * from "./OrthoTreatmentControls.vue?vue&type=script&lang=js&"
import style0 from "./OrthoTreatmentControls.vue?vue&type=style&index=0&id=41dff665&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dff665",
  null
  
)

export default component.exports